module.exports = __webpack_public_path__ + "img/icon01.80f0396.png";